module.exports = __webpack_public_path__ + "static/media/img_logos.e453b04f.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/solution/images/img_logos.png
// module id = 386
// module chunks = 4